@if (vm.currentPromotedFeaturePopIn) {
    <div
        class="d-flex justify-content-center align-items-center flex-column"
        [class.onboarding-introduction__fullscreen]="vm.isSupademoMode"
    >
        @if (vm.currentPromotedFeaturePopIn.title) {
            <eb-h2 class="text-center">
                {{ vm.currentPromotedFeaturePopIn.title | transloco }}
            </eb-h2>
        }
        @if (vm.currentPromotedFeaturePopIn.slogan) {
            <eb-h3 class="onboarding-introduction__slogan">
                {{ vm.currentPromotedFeaturePopIn.slogan | transloco }}
            </eb-h3>
        }
        <div
            class="onboarding-introduction__container"
            [class.onboarding-introduction__container--supademo]="vm.isSupademoMode"
            [class.onboarding-introduction__container--video]="vm.currentPromotedFeaturePopIn.video"
        >
            @if (vm.currentPromotedFeaturePopIn.video && vm.currentPromotedFeaturePopIn.explanations.length > 0) {
                <div class="onboarding-introduction__explanations mb-3">
                    @for (sentence of vm.currentPromotedFeaturePopIn.explanations; track sentence) {
                        <p class="p-0 m-0">
                            <eb-label
                                [innerHTML]="sentence | transloco | markdown"
                                [size]="'lg'"
                            />
                        </p>
                    }
                </div>
            }

            @if (vm.currentPromotedFeaturePopIn.video; as video) {
                @if (video.type === VideoTypes.YOUTUBE || video.type === VideoTypes.SUPADEMO) {
                    <div
                        class="onboarding-introduction__video-embed"
                        [class.onboarding-introduction__video-embed--supademo]="video.type === VideoTypes.SUPADEMO"
                    >
                        <iframe
                            [style.opacity]="isIframeLoaded() || video.type !== VideoTypes.SUPADEMO ? 1 : 0"
                            [src]="video.url | safe"
                            (load)="isIframeLoaded.set(true)"
                            allowfullscreen
                            frameborder="0"
                            height="100%"
                            title="Présentation de la feature"
                            width="100%"
                        ></iframe>
                    </div>
                }
                @if (video.type === VideoTypes.DIRECT) {
                    <vg-player class="onboarding-introduction__player">
                        <vg-overlay-play vgFor="popin-video" />
                        <vg-buffering />
                        <vg-controls>
                            <vg-play-pause />
                            <vg-scrub-bar>
                                <vg-scrub-bar-current-time />
                                <vg-scrub-bar-buffering-time />
                            </vg-scrub-bar>
                            <div class="d-flex">
                                <vg-time-display
                                    vgFormat="mm:ss"
                                    vgProperty="current"
                                />
                                <vg-mute />
                                <vg-volume />
                                <vg-fullscreen />
                            </div>
                        </vg-controls>
                        <video
                            id="popin-video"
                            #media
                            [vgMedia]="media"
                            preload="auto"
                        >
                            <source
                                type="video/mp4"
                                [src]="video.url"
                            />
                        </video>
                    </vg-player>
                }
            } @else {
                <div class="onboarding-introduction__wrapper">
                    @if (vm.currentPromotedFeaturePopIn.illustration) {
                        <eb-icon
                            [icon]="vm.currentPromotedFeaturePopIn.illustration"
                            width="200"
                        />
                    }
                    @if (vm.currentPromotedFeaturePopIn.explanations.length > 0) {
                        <div class="onboarding-introduction__explanations">
                            @for (sentence of vm.currentPromotedFeaturePopIn.explanations; track sentence) {
                                <p class="p-0 m-0">
                                    <eb-label
                                        [innerHTML]="sentence | transloco | markdown"
                                        [size]="'lg'"
                                    />
                                </p>
                            }
                        </div>
                    }
                </div>
            }
            @if (!vm.currentPromotedFeaturePopIn.video) {
                <div class="d-flex align-items-center justify-content-center gap-3 mt-4">
                    @for (cta of vm.currentPromotedFeaturePopIn.ctas; track cta) {
                        <button
                            eb-button
                            ebTracking
                            type="button"
                            [isV2]="true"
                            [outline]="false"
                            [trackingAction]="cta.tracking"
                            (click)="triggerCTAByPromotedFeatureId(cta)"
                            color="primary-v2"
                            size="small"
                            >{{ cta.title || 'common.ok' | transloco }}
                        </button>
                    }
                </div>
            }
        </div>
    </div>
}
